import { render, staticRenderFns } from "./SerieNumeroFormGeneral.vue?vue&type=template&id=16ab23ed&"
import script from "./SerieNumeroFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports